import template from './was-this-useful-share.component.html';
var WasThisUsefulShareComponentController = /** @class */ (function () {
    function WasThisUsefulShareComponentController($location) {
        this.$location = $location;
        this.isExpanded = false;
        this.hashInShareUrl = true;
        this.isShareLinkVisible = false;
    }
    WasThisUsefulShareComponentController.prototype.$onChanges = function () {
        if (!this.isExpanded) {
            this.isShareLinkVisible = false;
        }
    };
    WasThisUsefulShareComponentController.prototype.getShareItemLink = function () {
        if (this.itemUrl) {
            return this.itemUrl;
        }
        if (!this.hashInShareUrl) {
            return document.location.href;
        }
        var location = document.location;
        var url = location.protocol + "//" + location.host + location.pathname;
        var urlHash = "" + this.itemLink;
        if (this.$location.hash()) {
            urlHash += "#" + this.$location.hash();
        }
        return url + "#/" + urlHash;
    };
    Object.defineProperty(WasThisUsefulShareComponentController.prototype, "emailHref", {
        get: function () {
            return "mailto:?body=" + this.getShareItemLink();
        },
        enumerable: false,
        configurable: true
    });
    WasThisUsefulShareComponentController.prototype.showShareLink = function () {
        if (this.onShowShareLink) {
            this.onShowShareLink();
        }
        this.isShareLinkVisible = true;
    };
    Object.defineProperty(WasThisUsefulShareComponentController.prototype, "isVisible", {
        get: function () {
            return this.isExpanded && this.isShareLinkVisible;
        },
        enumerable: false,
        configurable: true
    });
    WasThisUsefulShareComponentController.prototype.copy = function (event) {
        var target = event.target;
        var inputTarget = target.previousElementSibling;
        var successful;
        inputTarget.focus();
        inputTarget.setSelectionRange(0, inputTarget.value.length);
        successful = document.execCommand && document.execCommand('copy');
        if (!successful) {
            prompt('', inputTarget.value);
        }
    };
    WasThisUsefulShareComponentController.$inject = ['$location'];
    return WasThisUsefulShareComponentController;
}());
export var WasThisUsefulShareComponent = {
    bindings: {
        isExpanded: '<?',
        itemLink: '<',
        itemUrl: '<?',
        hashInShareUrl: '<?',
        onShowShareLink: '&',
        pdfUrl: '<?',
    },
    controller: WasThisUsefulShareComponentController,
    template: template,
};
